


































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class HighValueReportBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly type!: string;

  @Prop() readonly switchActive!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly fetchResult!: Function;

  utilsInstance = utils;
}
